<template>
  <div>
    <a-row>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="REQUISICIONES APROBADOR POR CENTRO DE COSTO" key="1">
          <g-master name="aprobador_x_cc"
                    :endpoint="master.endpoint"
                    :tableSetup="master.tableSetup"
                    :modalFieldsSetup="master.modalFieldsSetup"
                    modalWidth="90%"
                    @action="masterAction"
                    ref="master"
          >
            <template slot="masterModal" slot-scope="{record}">
              <a-row :gutter="[16,16]">
                <a-col v-bind="colOptions">
                  <g-lookup :label="$t('Empleado')"
                            :formItemConfig="fiOptions"
                            endpoint="empleados_en_reqliquidacion"
                            ref="empleado"
                            :decorator="['id_emp', { rules: [{ required: false, message: 'Valor requerido' }] }]">
                  </g-lookup>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown :label="$t('Centro de costo')"
                              endpoint="cc"
                              :rowKey="'id'"
                              :columns="columnasCentroCosto"
                              :saveValue="'id'"
                              :hasMultipleRows="true"
                              @model="modeloRecibido"
                              :formItemConfig="fiOptions"
                              :decorator="['id_cc', { rules: [{ required: false, message: 'Valor requerido' }]}]">
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="role"
                              :label="$t('Rol') "
                              :formItemConfig="fiOptions"
                              :decorator="['role_name', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                              :params="paramsRole"
                  >
                  </g-dropdown>
                </a-col>
              </a-row>
            </template>
          </g-master>
        </a-tab-pane>
      </a-tabs>
    </a-row>

    <a-row>
    </a-row>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        paramsRole: {
          like: 'REQ_WF'
        },
        columnasCentroCosto: [
          {title: 'ID', dataIndex: 'id', sorter: true},
          {title: 'ID CC', dataIndex: 'cc_id', sorter: true},
          {title: 'Nombre CC', dataIndex: 'cc_name', sorter: true},
          {title: this.$t('PERSONALIZACION_CENTRO_COSTO_ID_SEGMENTO'), dataIndex: 'segment_id', sorter: true},
          {title: 'Nombre Segmento', dataIndex: 'segment_name', sorter: true},
          {title: this.$t('PERSONALIZACION_CENTRO_COSTO_ID_UNIDAD'), dataIndex: 'unit_id', sorter: true},
          {title: 'Nombre Unidad', dataIndex: 'unit_name', sorter: true},
          {title: this.$t('PERSONALIZACION_CENTRO_COSTO_ID_PROYECTO'), dataIndex: 'prj_id', sorter: true},
          {title: 'Nombre Proyecto', dataIndex: 'prj_name', sorter: true}
        ],
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'requisition_hierarchy_cc',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: '#', dataIndex: 'id', sorter: true},
              {title: 'Empleado', dataIndex: 'nombre', sorter: true},
              {title: 'ID Centro costo', dataIndex: 'id_cc', sorter: true},
              {title: 'Centro costo', dataIndex: 'cc', sorter: true},
              {title: 'Rol', dataIndex: 'role_name', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'id_cc'},
            {name: 'id_emp'},
            {name: 'role_name'}
          ]
        }
      }
    },
    methods: {
      modeloRecibido (value) {
        this.$refs.master.modal.form.setFieldsValue({
          id_cc: value
        })
      },
      masterAction (action) {
        switch (action.action) {
          case 'masterEdit':
            if (!this.$isEmpty(action.record.id_emp)) {
              this.$refs.empleado && this.$refs.empleado.handleSearch(action.record.id_emp)
            }
            break
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Company/MantenimientoRequisitionHierarchyCc.vue